module.exports = __webpack_public_path__ + "static/media/ending-balls.8733be19.png";